var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-item"},[_c('span',{directives:[{name:"handle",rawName:"v-handle"}],staticClass:"handle"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icons.handle}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }